module.exports = __webpack_public_path__ + "static/media/angle-double-right.7d6601eb.svg";